import { render, staticRenderFns } from "./DSSupplyFields.vue?vue&type=template&id=355ec7fa&"
import script from "./DSSupplyFields.vue?vue&type=script&lang=js&"
export * from "./DSSupplyFields.vue?vue&type=script&lang=js&"
import style0 from "./DSSupplyFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports